import {Grid} from "@material-ui/core";
import BoxWithImage from "../../../../../../../../../../shared/components/box-with-image/BoxWithImage";
import IconBigCoins from "../../../../../../../../../../assets/images/icon-big-coins-88-px.svg";
import IconSim from "../../../../../../../../../../assets/images/icon-big-sim-88-px.png";
import IconFatture from "../../../../../../../../../../assets/images/icon-big-fatture-88-px.svg";
import IconCalendar from "../../../../../../../../../../assets/images/icon-big-calendar-88-px.svg";
import IconExtraShare from '../../../../../../../../../../assets/images/icon-big-share-88-px.svg';
import PropTypes from "prop-types";
import Box from "@material-ui/core/Box";
import {useSelector} from "react-redux";
import {Skeleton} from "@material-ui/lab";

const CardsWithImages = (props) => {
    const currentOffer = useSelector(state => state.contrattoDigitaleReducer.currentOffer.data)
    const loading = useSelector(state => state.contrattoDigitaleReducer.currentOffer.loading)

    const cardsWithImages = [
        {
            title: "Contributo attivazione",
            content: props.planCardsData.activationPriceDisplayValue,
            image: IconBigCoins
        },
        {title: "Canone unitario", content: props.planCardsData.monthlyPriceDisplayValue, image: IconBigCoins},
        {title: "Numero sim", content: props.planCardsData.numberOfSimsDisplayValue, image: IconSim},
        {title: "Tipologia", content: props.planCardsData.tipologia, image: IconFatture}
    ]

    const cardsWithImagesPlafondShare = [
        {title: "Numero sim", content: props.planCardsData.numberOfSimsDisplayValue, image: IconSim},
        {
            title: "Contributo attivazione",
            content: props.planCardsData.activationPriceDisplayValue,
            image: IconBigCoins
        },
        {title: "Canone unitario", content: props.planCardsData.monthlyPriceDisplayValue, image: IconBigCoins},
        {title: "Plafond", content: loading ? <Skeleton height={`40px`} animation='wave'/> : currentOffer.plafond, image: IconExtraShare},
        {title: "Tipologia", content: props.planCardsData.tipologia, image: IconFatture},
        {title: "Data prossimo rinnovo", content: loading ? <Skeleton height={`40px`} animation='wave'/> : currentOffer.dataProssimoRinnovo, image: IconCalendar}
    ]

    return (
        <Box my='1em'>
            <Grid container spacing={2}>
                {(props.isPlafondShare || props.isPlan ? cardsWithImagesPlafondShare : cardsWithImages).map((card) => {
                    return (
                        <Grid item lg={props.isPlafondShare || props.isPlan ? 4 : 3} sm={6} xs={12} key={"card-id-" + card.title}>
                            <BoxWithImage title={card.title}
                                          content={card.content}
                                          image={card.image}/>
                        </Grid>
                    )
                })}
            </Grid>
        </Box>

    )
}

CardsWithImages.propTypes = {
    planCardsData: PropTypes.shape({
        itemName: PropTypes.string,
        activationPriceDisplayValue: PropTypes.string.isRequired,
        monthlyPriceDisplayValue: PropTypes.string.isRequired,
        numberOfSimsDisplayValue: PropTypes.string.isRequired,
        tipologia: PropTypes.string.isRequired,
    }).isRequired,
    isPlafondShare: PropTypes.bool
}

export default CardsWithImages
